import { COUNTRY, type CountryEnumBaseExtraData } from '@nfctron/nexus-core';
import { type CountryEnumReactData, type CountryEnumReactExtraDataExtend, countryEnumReact } from '@nfctron/nexus-react';

import { EnumHelper } from './helpers';

export interface CountryEnumTicketsExtraDataExtend extends CountryEnumReactExtraDataExtend {}

export interface CountryEnumTicketsData extends CountryEnumReactData, CountryEnumTicketsExtraDataExtend {}

/**
 * Country enumeration with extra data for Tickets
 * @extends {typeof countryEnumBase} Base country enumeration
 */
class CountryEnumTickets extends EnumHelper<
	CountryEnumBaseExtraData,
	COUNTRY,
	typeof countryEnumReact.enumName,
	typeof countryEnumReact.idKey,
	CountryEnumTicketsExtraDataExtend
> {
	constructor() {
		super(
			countryEnumReact.enumName,
			countryEnumReact.data,
			countryEnumReact.idKey,
			countryEnumReact.extendWith({
				[COUNTRY.CZE]: {},
				[COUNTRY.SVK]: {},
				[COUNTRY.AUT]: {},
				[COUNTRY.GBR]: {},
				[COUNTRY.SRB]: {},
				[COUNTRY.BEL]: {},
				[COUNTRY.BGR]: {},
				[COUNTRY.HRV]: {},
				[COUNTRY.CYP]: {},
				[COUNTRY.DNK]: {},
				[COUNTRY.EST]: {},
				[COUNTRY.FIN]: {},
				[COUNTRY.FRA]: {},
				[COUNTRY.DEU]: {},
				[COUNTRY.GRC]: {},
				[COUNTRY.HUN]: {},
				[COUNTRY.IRL]: {},
				[COUNTRY.ITA]: {},
				[COUNTRY.LVA]: {},
				[COUNTRY.LTU]: {},
				[COUNTRY.LUX]: {},
				[COUNTRY.MLT]: {},
				[COUNTRY.POL]: {},
				[COUNTRY.PRT]: {},
				[COUNTRY.ROU]: {},
				[COUNTRY.SVN]: {},
				[COUNTRY.ESP]: {},
				[COUNTRY.SWE]: {},
				[COUNTRY.NLD]: {},
				[COUNTRY.ISL]: {},
				[COUNTRY.LIE]: {},
				[COUNTRY.NOR]: {},
				[COUNTRY.CHE]: {},
			}),
		);
	}
}

export const countryEnumTickets = new CountryEnumTickets();
